// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"index_breadcrumbs_1PNOq","path":"index_path_2H21N","arrow":"index_arrow_1cdLN"};